import React from 'react';

export const severabilityMessages = {
  value: 'Severability',
  list: [
    {
      value: (
        <>
          The provisions of the Terms and Conditions shall be enforceable
          independently of each other and the validity of each provision shall
          not be affected if any of the others is invalid. In the event that any
          provision or any part of a provision of the Terms and Conditions is
          determined to be or becomes illegal, invalid or unenforceable, the
          validity and enforceability of the remaining provisions or remaining
          part of the provision of the Terms and Conditions shall not be
          affected and, in lieu of such illegal, invalid, or unenforceable
          provision or part of a provision, there shall be added as part of the
          Terms and Conditions one or more provisions as similar in terms as may
          be legal, valid and enforceable under the applicable law.
        </>
      ),
    },
  ],
};
